import { AxiosResponse } from 'axios';

const PROTECTED_IBAN_LENGTH = 10;

import {
  BankAccount,
  BankAccountSnakeCase,
  PaymentsAccountInfo,
} from '../../shared/ts/payments';
import httpRequest from '../httpRequest';

const convertBankAccountResponseToCamelCase = (
  bankAccount: BankAccountSnakeCase,
) => {
  return {
    accountHolderName: bankAccount.account_holder_name,
    bankName: bankAccount.bank_name,
    country: bankAccount.country,
    IBAN: bankAccount.last4.padStart(PROTECTED_IBAN_LENGTH, '*'),
    isDefault: bankAccount.default,
    id: bankAccount.id,
  };
};

const paymentsAPI = {
  getBankAccounts: async (): Promise<BankAccount[]> => {
    const { data } = (await httpRequest({
      url: `/user/bank-accounts`,
      method: 'GET',
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
    })) as AxiosResponse;

    return data.map(convertBankAccountResponseToCamelCase);
  },
  createBankAccount: async (
    accountHolderName: string,
    IBAN: string,
    isDefault: boolean,
  ): Promise<BankAccount> => {
    const payload = {
      account_holder_name: accountHolderName,
      iban: IBAN,
      default: isDefault,
    };

    const { data } = (await httpRequest({
      url: `/user/bank-accounts`,
      method: 'POST',
      data: payload,
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
    })) as AxiosResponse;

    return convertBankAccountResponseToCamelCase(data);
  },
  updateBankAccount: async (
    id: string,
    accountHolderName: string,
    isDefault: boolean,
  ): Promise<BankAccount> => {
    const payload = {
      account_holder_name: accountHolderName,
      default: isDefault,
    };

    const { data } = (await httpRequest({
      url: `/user/bank-accounts/${id}`,
      method: 'PUT',
      data: payload,
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
    })) as AxiosResponse;

    return convertBankAccountResponseToCamelCase(data);
  },
  getAccountInfo: async (): Promise<PaymentsAccountInfo> => {
    const { data } = (await httpRequest({
      url: `/user/payment-account`,
      method: 'GET',
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
    })) as AxiosResponse;

    return {
      areChargesEnabled: data.charges_enabled,
      arePayoutsEnabled: data.payouts_enabled,
      areTOSAccepted: data.tos_accepted,
    };
  },
  acceptTermsOfService: async (): Promise<void> => {
    await httpRequest({
      url: `/user/terms-of-service/accept`,
      method: 'POST',
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
    });
  },
};

export default paymentsAPI;
